export const isValidAmountInputValue = (value: string) => {
  const commaSeparatedNumbersRegex = new RegExp(/^\d+,?\d{0,2}?$/g);
  return value === '' || commaSeparatedNumbersRegex.test(value);
};
